export default {
    url: '/by_days',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 901,
        title: 'By days',
        role: 'conversion_rate',
    },
    controller: [
        '$scope',
        '$location',
        'conversion_rate_api',
        'chartFilters',
        function($scope, $location, conversion_rate_api, chartFilters) {
            $scope.data = {};
            $scope.ranges = {};
            $scope.gradient_colors = [
                '#ecf8ff',
                '#E6F5FF',
                '#DBF0FF',
                '#D1ECFF',
                '#C7E8FF',
                '#BDE4FF',
                '#B3E0FF',
                '#A8DCFF',
                '#9ED8FF',
                '#94D4FF',
                '#8AD0FF',
                '#80CCFF',
                '#78c4ff',
            ];
            $scope.update_conversion_rate_table = function(model) {
                conversion_rate_api.data_by_days(model).then(function(resp) {
                    $scope.data = resp;
                    $scope.calculate_ranges();
                });
            };
            $scope.calculate_ranges = function() {
                let data_keys = Object.keys($scope.data[0]);
                for (let key_i = 0; key_i < data_keys.length; key_i++) {
                    let values_list = [];
                    for (let i = 0; i < $scope.data.length; i++) {
                        values_list.push($scope.data[i][data_keys[key_i]]);
                    }
                    $scope.ranges[data_keys[key_i]] = {
                        min: Math.min.apply(Math, values_list),
                        max: Math.max.apply(Math, values_list),
                    };
                }
            };
            $scope.apply_color = function(value, key) {
                if (value !== -1) {
                    let position =
                        (value - $scope.ranges[key]['min']) /
                        ($scope.ranges[key]['max'] - $scope.ranges[key]['min']);
                    return $scope.gradient_colors[Math.floor(position * ($scope.gradient_colors.length - 1))];
                }
            };
            $scope.apply = function(value) {
                return value === -1 ? '-' : value;
            };
            chartFilters.onChangeChartParams(
                'update_conversion_rate_table',
                $scope.update_conversion_rate_table,
            );
            $scope.update_conversion_rate_table(chartFilters.get_chart_filters());
        },
    ],
};
